import { faCat, faDog, faTurtle } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react';
import { PetType, PetTypeIds } from 'types/Pet';

import classes from './PetChip.module.scss';

interface PetChipProps {
    id?: string;
    petName: string;
    petType: PetType;
    active?: boolean;
    checked?: boolean;
    warning?: boolean;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const PetChip = React.forwardRef<HTMLButtonElement, PetChipProps>(
    (props: PetChipProps, ref) => {
        const petIcon = React.useMemo(() => {
            if (props.petType.id === PetTypeIds.DOG) {
                return <FontAwesomeIcon icon={faDog} />;
            }

            if (props.petType.id === PetTypeIds.CAT) {
                return <FontAwesomeIcon icon={faCat} />;
            }

            if (props.petType.id === PetTypeIds.EXOTIC) {
                return <FontAwesomeIcon icon={faTurtle} />;
            }

            return null;
        }, [props.petType]);

        return (
            <button
                ref={ref}
                id={props.id}
                onClick={props.onClick}
                className={clsx(classes.root, props.className, {
                    [classes.active]: props.active,
                    [classes.checked]: props.checked || props.warning,
                    [classes.bgDog]: props.petType.id === PetTypeIds.DOG,
                    [classes.bgCat]: props.petType.id === PetTypeIds.CAT,
                    [classes.bgExotic]: props.petType.id === PetTypeIds.EXOTIC
                })}
            >
                <span
                    className={clsx(classes.icon, {
                        [classes.iconDog]: props.petType.id === PetTypeIds.DOG,
                        [classes.iconCat]: props.petType.id === PetTypeIds.CAT,
                        [classes.iconExotic]: props.petType.id === PetTypeIds.EXOTIC
                    })}
                >
                    {petIcon}
                </span>

                <span className={classes.petName}>
                    {props.petName}
                    {props.warning ? (
                        <FontAwesomeIcon
                            icon={faTriangleExclamation}
                            className={classes.warningIcon}
                        />
                    ) : (
                        props.checked && (
                            <FontAwesomeIcon icon={faCheckCircle} className={classes.checkIcon} />
                        )
                    )}
                </span>
            </button>
        );
    }
);

PetChip.displayName = 'PetChip';
